export const ReffererLayoutQueryName = 'referrer-layout'
